(function () {
  'use strict'

  // If cookies are disabled in the browser then redirect to a static page
  angular.module('account.init', ['ngCookies'])
    .run(detectCookies)
    .run(startApp)

  function detectCookies ($cookies) {
    $cookies.put('testCookie', 'test')
    if ($cookies.get('testCookie') !== 'test') {
      window.location.href = `enable-cookies.html?backTo=${window.location.href}`
    }
    $cookies.remove('testCookie')
  }

  function bootstrapAngularApp () {
    // Load app script and bootsrap angular app.
    $.ajax({
      crossDomain: true,
      dataType: 'script',
      cache: true,
      url: 'scripts/app.js',
      success: () => angular.bootstrap(document, ['account'])
    })
  }

  const getBaseWidgetsUrl = (locale, stage = 'prd') => {
    switch (locale) {
      case 'sd_SD':
      case 'sd_IE':
        return stage !== 'prd' ? 'https://preview.onlinedoctor.superdrug.com/widgets' : 'https://onlinedoctor.superdrug.com/widgets'
      case 'as_AS':
        return stage !== 'prd' ? 'https://preview.onlinedoctor.asda.com/widgets' : 'https://onlinedoctor.asda.com/widgets' // Need to do this to get around CORS issues just for staging ASDA
      case 'de_DE':
      default:
        return 'https://widgets.zavamed.com'
    }
  }

  const getPatientAccountExperienceUrl = (locale, stage) => {
    const AccountExpfeaPath = (window.__env && window.__env.ACCOUNT_EXPERIENCE_PATH) || 'master123'
    const AccountExpfeaBranch = (window.__env && window.__env.ACCOUNT_EXPERIENCE_BRANCH) || 'master'
    if (stage === 'stg') {
      switch (locale) {
        case 'sd_SD':
        case 'sd_IE':
          return 'https://api-sd-preview.dred.com/patient-account'
        case 'as_AS':
          return 'https://api-preview.onlinedoctor.asda.com/patient-account'
        case 'de_DE':
        default:
          return 'https://stg-api.zavamed.com/patient-account'
      }
    } else if ((stage === 'feature') && (AccountExpfeaBranch === 'master')) {
      return 'https://stg-api.zavamed.com/patient-account'
    } else if ((stage === 'feature') && (AccountExpfeaBranch !== 'master')) {
      return `https://bff.feature.zavasrv.com/patient-account-${AccountExpfeaPath}`
    } else {
      switch (locale) {
        case 'sd_SD':
        case 'sd_IE':
          return 'https://api.onlinedoctor.superdrug.com/patient-account'
        case 'as_AS':
          return 'https://api.onlinedoctor.asda.com/patient-account'
        default:
          return 'https://api.zavamed.com/patient-account'
      }
    }
  }

  const loadMfpHelper = (locale, stage) => {
    const baseUrl = getBaseWidgetsUrl(locale, stage)

    const SharedStage = (stage === 'feature') ? 'stg' : stage

    const mfpScriptTag = document.createElement('script')
    mfpScriptTag.setAttribute('src', `${baseUrl}/microfrontend-shared/${SharedStage}/microfrontend-parcel/mfp.iife.js`)
    document.head.appendChild(mfpScriptTag)
  }

  const generateSystemJsImportMapAndEnv = (locale, stage) => {
    const baseUrl = getBaseWidgetsUrl(locale, stage)

    const WsPatientAccountUi = (window.__env && window.__env.WS_PATIENT_ACCOUNT_UI_STAGE) || 'stg'

    const WsStage = (stage === 'feature') ? (WsPatientAccountUi === 'stg') ? 'stg' : `feature/${WsPatientAccountUi}` : stage

    const MfeStage = (stage === 'feature') ? 'stg' : stage

    const importMap = {
      imports: {
        'diagnostic-patient-ui': `${baseUrl}/diagnostic-patient-ui/${MfeStage}/js/app.js`,
        'diagnostic-patient-results-ui': `${baseUrl}/diagnostic-patient-results-ui/${MfeStage}/js/app.js`,
        '@ws-patient-account-ui/navigation': `${baseUrl}/ws-patient-account-ui/${WsStage}/navigation/js/app.js`,
        '@ws-patient-account-ui/file-upload': `${baseUrl}/ws-patient-account-ui/${WsStage}/file-upload/js/app.js`,
        '@ws-patient-account-ui/id-check': `${baseUrl}/ws-patient-account-ui/${WsStage}/id-check/js/app.js`,
        '@ws-patient-account-ui/dashboard': `${baseUrl}/ws-patient-account-ui/${WsStage}/dashboard/js/app.js`,
        '@ws-patient-account-ui/digital-prescription': `${baseUrl}/ws-patient-account-ui/${WsStage}/digital-prescription/js/app.js`,
        '@healthbridge-design-system/components': `${baseUrl}/hb-design-system/${MfeStage}/hb-design-system.0.5.x.amd.js`,
        'vue': `${baseUrl}/microfrontend-shared/${MfeStage}/vue.amd.js`
      }
    }

    const im = document.createElement('script')
    im.type = 'systemjs-importmap'
    im.textContent = JSON.stringify(importMap)
    document.head.appendChild(im)

    // add the widgets url as an env variable that can be accessed elsewhere
    const meta = document.createElement('meta')
    meta.id = 'widgetsUrl'
    meta.setAttribute('data-url', baseUrl)
    document.head.appendChild(meta)

    return new Promise((resolve) => {
      if (stage !== 'prd') {
        // Add importmap override
        const importMeta = document.createElement('meta')
        importMeta.name = 'importmap-type'
        importMeta.content = 'systemjs-importmap'
        document.head.appendChild(importMeta)

        const overrideScript = document.createElement('script')
        overrideScript.src = 'https://www.zavamed.com/zava-assets/dist/scripts/import-map-overrides.js'
        overrideScript.addEventListener('load', () => {
          resolve()
        })
        document.head.appendChild(overrideScript)
      } else {
        resolve()
      }
    })
  }

  const setPatientAccountExperienceEnv = (locale, stage) => {
    const patientAccountExperienceUrl = getPatientAccountExperienceUrl(locale, stage)
    const meta = document.createElement('meta')
    meta.id = 'accountExperienceApiUrl'
    meta.setAttribute('data-url', patientAccountExperienceUrl)
    document.head.appendChild(meta)
  }

  function startApp ($http, $q) {
    let { pseudoLocale: locale, urlPrefix } = window.getLocaleFromUrl()

    const appendElementsToHead = (siteInfo) => {
      // Add Site related css
      angular.element('head').append(`<link rel="stylesheet" href="assets/stylesheets/site-${siteInfo.site}.css"/>`)

      const isZava = siteInfo.site === 'zava'
      const isAsda = siteInfo.site === 'asda'
      const faviconPath = isZava ? 'zava/' : 'asda/'
      const brandColor = isZava ? '#0F62F4' : '#68A51C'

      // Favicons and mobile header BG
      if (isZava || isAsda) {
        angular.element('head').append(`<link rel="apple-touch-icon" sizes="180x180" href="${siteInfo.currentRootUrl}zava/assets/images/favicons/${faviconPath}apple-icon-180x180.png">`)
        angular.element('head').append(`<link rel="icon" type="image/png" sizes="96x96" href="${siteInfo.currentRootUrl}zava/assets/dist/images/favicons/${faviconPath}favicon-96x96.png">`)
        angular.element('head').append(`<link rel="icon" type="image/png" sizes="32x32" href="${siteInfo.currentRootUrl}zava/assets/images/favicons/${faviconPath}favicon-32x32.png">`)
        angular.element('head').append(`<link rel="icon" type="image/png" sizes="16x16" href="${siteInfo.currentRootUrl}zava/assets/images/favicons/${faviconPath}favicon-16x16.png">`)
        angular.element('head').append(`<meta name="msapplication-TileColor" content="${brandColor}">`)
        angular.element('head').append(`<meta name="msapplication-TileImage" content="${siteInfo.currentRootUrl}/assets/dist/images/favicons/${faviconPath}ms-icon-144x144.png">`)
        angular.element('head').append('<meta name="msvalidate.01" content="DFA0EDE64C29F5E07C8C9F865B66ECA1" />')
        angular.element('head').append(`<meta name="theme-color" content="${brandColor}">`)
      }

      const stage = document.querySelector('html.loading').dataset.stage

      generateSystemJsImportMapAndEnv(locale, stage).then(() => loadMfpHelper(locale, stage))
      setPatientAccountExperienceEnv(locale, stage)
    }

    // Get Site Info
    if (urlPrefix && urlPrefix.startsWith('/')) {
      urlPrefix = urlPrefix.substring(1)
    }

    $http.get(`${urlPrefix.length ? '/' + urlPrefix : ''}/api/v2/sites?locale=${locale}`).then((response) => {
      if (response.data.site === 'tosca') {
        response.data.site = 'asda'
      }
      window.siteInfo = response.data

      document.getElementsByTagName('html')[0].setAttribute('lang', window.siteInfo.actualLocale.replace('_', '-'))
      appendElementsToHead(window.siteInfo)
      // Load and bootstrap angular app
      bootstrapAngularApp()
    })
  }
})()
